import { Button, Input, Label, toast } from "@awtoban/ui";
import { useNavigate } from "@tanstack/react-router";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { LocaleSwitcher } from "../../i18n/LocaleSwitcher";
import { useAuth } from "./AuthProvider";

export function LoginPage() {
  const { t } = useTranslation();
  const auth = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);

  React.useEffect(() => {
    if (auth.isAuthenticated) void navigate({ to: "/" });
  }, [auth.isAuthenticated, navigate]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await auth.login(username, password);
      void navigate({ to: "/" });
    } catch {
      toast.error(t("auth.login_failed"), { description: t("auth.check_credentials") });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center px-6">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-md border border-line-strong bg-paper p-8 shadow-sm"
      >
        <div className="mb-6 flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h1 className="font-semibold text-2xl tracking-tight">{t("app.title")}</h1>
            <p className="mt-1 text-ink-muted text-sm">{t("auth.sign_in_subtitle")}</p>
          </div>
          <div className="shrink-0">
            <LocaleSwitcher />
          </div>
        </div>

        <div className="mb-4">
          <Label htmlFor="u">{t("auth.username")}</Label>
          <Input
            id="u"
            inputSize="lg"
            autoFocus
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="mb-6">
          <Label htmlFor="p">{t("auth.password")}</Label>
          <Input
            id="p"
            type="password"
            inputSize="lg"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <Button type="submit" size="lg" className="w-full" disabled={submitting}>
          {submitting ? t("auth.signing_in") : t("auth.sign_in")}
        </Button>
      </form>
    </div>
  );
}
